<template>
  <div class="main">
    <!-- loading 一键生成 -->
    <div
      class="loadings"
      v-if="loading"
      v-loading="{ visible: loading, text: loadingtext }"
    ></div>
    <heads></heads>
    <banners></banners>
    <div class="content">
      <div class="cons">
        <!-- 生成论文 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">论文写作</div>
            <el-form-item label="标题">
              <el-input v-model="form2.bt" placeholder="请输入标题" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="clickdagang()"
                >立即生成</el-button
              >
              <el-button type="warning" @click="clickdownload()"
                >下载文档</el-button
              >
            </div>
            <el-form-item label="论文详情">
              <el-input autosize type="textarea" v-model="reslunwen" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { post } from "@/utils/index";
import { ElMessage, ElMessageBox } from "element-plus";
import { reactive, ref, inject, getCurrentInstance } from "vue";
import "echarts-wordcloud";
import { useRouter } from "vue-router";

const router = useRouter();
const { proxy } = getCurrentInstance();

const baseurls = "http://server-1:8055";
// loading
let loading = ref(false);
let loadingtext = ref(" ");
let randsum = 0;
// 提纲
let tigang = ref("");
// 引言
let yinyan = ref("");
let cankaowenxian = ref("参考文献：\n");
// 摘要关键词
let zhaiyaoguanjiancitemp = ref("");
let zhaiyaoguanjianci = ref("");
// 结束语
let jieshuyu = ref("");
// 每个问题的结果
let reswenti1 = ref("");
let reswenti2 = ref("");
let reswenti3 = ref("");
let reswenti4 = ref("");

let reswenti6 = ref("");
// 全文
let reslunwen = ref("");
// let reslunwenmini = ref("");

let resobj = ref("");
let form = reactive({
  keys: "",
  bt: "",
  ckwx: [],
  writerorg: `学术论文“论文标题“选择要求有一定的“创新性“、”实用性“和”科学性“等要求。假如你是一名顶级学者，请围绕 “@标题@”的中心内容意思，生成十篇题目供参考，每个论文标题只写一句话。中间不能出现符号，又如“ XXX”，输出格式为：
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX．
请注意用Markdown格式输出, 以下是关键词：`,
  writerorg2: "",
  resobj: "",
});
let form2 = reactive({
  bt: "",
  zz: "顶级学者",
  writerorg: `假如你是一名@身份@，请围绕“@标题@”的中心内容意思，并结合提交的“核心词”，精心生成一篇教学论文学术写作提纲，注意：学术论文写作有格式规范，请务必注意用专业术语。
要求如下：
1、要求论文提纲的各级标题有新颖性，大小标题之间在有关联性，并注意结构相对工整。每个标题只写一句话。围绕“@标题@”写提纲分为六部分。如示例。
2、请注意用阿拉伯数字编号。如“0；1，1.1，1.2，1.3，1.4；2，2.1，2.2，2.3，2.4；3，3.1，3.2，3.3，3.4；4，4.1，4.2，4.3，4.4；5结束语”的示例。如示例写到二级标题，每一级都要按示例写满，不要多写也不要少写。再比如 “1、2、3、4”这四个一级标题，在逻辑上有相关性，且是围绕“@标题@”展开拟写的。再比如：“X.1，X.2，X.3，X.4”这种二级标题，在逻辑上有相关性，且是围绕“X”展开拟写的。
3、教学学术论文“引言”请按标准的教学学术论文要求进行写作、修改、润色。关于“引言”部分要特别注意要求如下：第一点，论文写作的背景是什么？第二点，论文研究的需求是什么？第三点，这篇论文的任务是什么？第四点，写这篇论文的目的是什么？第五点，在任务或论文目标中前导性地介绍你要采用或构造什么方法、获得什么样的结果以及期望什么样的结论。第六点，“引言”输出段落为一段。总体连成一段输出，且输出字数要控制在300字以上500字以内。
4、论文“引言”输出格式要求：按用一句话来描述“研究背景”→用一句话来描述“研究需求”→用一句话来描述“研究任务”→用一句话来描述“论文目标”。按这样的顺序介绍，一个也不能少，每一层意思只写一句话。
5、“引言”输出格式：（XXX写成一段）。
6、请根据以下关键词并进行组合，并用MARKDOWN格式输出。如(引言部分)（第一部分）（第二部分）（第三部分）（第四部分）（结束语部分），不要出现失误。输出格式为：
（引言部分）
0引言
XXX
（第一部分）
1 XXX
1.1 XXX
1.2 XXXX
1.3 XXXX
1.4 XXXX
（第二部分）
2 XXX
2.1 XXX
2.2 XXX
2.3 XXX
2.4 XXX
（第三部分）
3 XXX
3.1 XXX
3.2 XXX
3.3 XXX
3.4 XXX
（第四部分）
4 XXX
4.1 XXX
4.2 XXXX
4.3 XXXX
4.4 XXXX
（结束语部分）
5 结束语
核心词如下：`,
  writerorg2: "",
});
let form01 = reactive({
  writerorg2: "",
  writerorg: `请根据下面提交的大纲的中“第一部分”或者“1.X“的内容进行写作，不要展开其他部分内容。

要求：
1、在“1”和“1.1”之间展开写3句过渡性的重要语言。在“1.2 XXXX”中，结合教学实际，插入一段案例并进行分析。
2、每一个小节展开详细描述八百字（800字），不要分点描述，整合起来写。
3、请记住只写“指定”部分的相关内容2000字左右，阿拉伯数字序号都要原样保留。只输出大纲的中“第一部分”或者“1.X”的内容，而不要输出论文题目。
4、请注意每一个标题前面的阿拉伯数字序号都要原样保留，并对提纲重新提炼，结果输出中不要出现论文题目。
5、输出格式为：
“1 XXX
XXXXX（3句话）
1.1 XXXX
（写三层意思，800字左右）
1.2 XXXX
（写三层意思，800字左右）
1.3 XXXX
（写三层意思，800字左右）
1.4 XXXX
（写三层意思，800字左右）
（不写总结）
”
6、大纲如下：`,
});
let form02 = reactive({
  writerorg2: "",
  writerorg: `请根据下面提交的大纲的中“第二部分”或者“2.X”的内容进行写作，不要展开其他部分内容。
要求：
1、在“2”和“2.1”之间展开写3句重要的过渡性性语言。
2、每一个小节展开详细描述八百字（800字），但不要分点描述，整合起来写。在“2.1 XXXX”中，结合教学实际，插入一段案例并进行分析。
3、二级标题要输出，并前面的阿拉伯数字序号都要原样保留。如：“3，3.1，3.2，3.3，3.4”。必要时可以重新写提纲。
4、请记住只写“指定”的“第二部分”或者“2.X”部分的相关内容2500字左右，阿拉伯数字序号都要原样保留。不输出论文题目。
5、再次强调，输出“总字数”2500字以上，注意核对输出字数要求。
6、输出格式为：
“2 XXX
XXXXX（3句话）
2.1 XXXX
（写三层意思，800字左右）
2.2 XXXX
（写三层意思，800字左右）
2.3 XXXX
（写三层意思，800字左右）
2.4 XXXX
（写三层意思，800字左右）
”
7、大纲如下：`,
});
let form03 = reactive({
  writerorg2: "",
  writerorg: `请根据下面提交的大纲的中“第三部分”或者“3.X”的内容进行写作，不要展开其他部分内容。
要求：
1、在“3”和“3.1”之间先展开写3句重要的过渡性语言。
2、每一个小节展开详细描述八百字（800字），但不要分点描述，整合起来写。
3、二级标题要输出，并前面的阿拉伯数字序号都要原样保留。如：“3，3.1，3.2，3.3，3.4”。必要时可以重新写提纲。
3、请记住不要展开写，只写“指定”的“第三部分”或者“3.X”部分的相关内容2500字左右，阿拉伯数字序号都要原样保留。只输出大纲的中“第三部分”或者“3.X”的内容，而不要输出论文题目。
4、强调一下：“3.1	XXX”，这一部分要插入举例说明，并有设计相关数值，这里一定要完善数据与数值，并进行分析，必要时可以插入一个表格，但要有表头与内容、注解等要素。
5、再次强调，输出“总字数”2500字以上，注意核对输出字数要求。
6、输出格式为：
“3 XXX
XXXXX（3句话）
3.1 XXXX
（写三层意思，800字左右）
3.2 XXXX
（写三层意思，800字左右）
3.3 XXXX
（写三层意思，800字左右）
3.4 XXXX
（写三层意思，800字左右）
（不写总结）
”
7、大纲如下：`,
});
let form04 = reactive({
  writerorg2: "",
  writerorg: `请根据下面提交的大纲的中“第四部分”或者“4.X”的内容进行写作，不要展开其他部分内容。
要求：
1、在“4”和“4.1”之间先展开只要重要的3句过渡性的语句。
2、每一个小节展开详细描述八百字（800字），但不要分点描述，整合起来写。
3、二级标题要输出，并前面的阿拉伯数字序号都要原样保留。如：“4，4.1，4.2，4.3，4.4”。必要时可以重新写提纲。
4、请记住不要展开写，只写“指定”的“第四部分”或者“4.X”部分相关内容2500字左右，阿拉伯数字序号都要原样保留。不要输出论文题目。
4、再次强调，输出“总字数”2500字以上，注意核对输出字数要求。
5、输出格式为：
“4 XXX
XXXXX（3句话）
4.1 XXXX
（写三层意思，800字左右）
4.2 XXXX
（写三层意思，800字左右）
4.3 XXXX
（写三层意思，800字左右）
4.4 XXXX
（写三层意思，800字左右）
”
6、大纲如下：`,
});

let form06 = reactive({
  writerorg2: "",
  writerorg: `接下来，根据最先提交的大纲写这篇教学论文学术的“结束语”部分。注意学术论文写作，有格式规范，请务必注意“结束语”写作的专业性，不要随意发挥。
请根据下面提交的大纲的中“结束语部分”内容进行写作，不要展开其他部分的内容。不要分点描述，而是要整合起来写。
只写“指定”的“结束语部分”或者“结束语”部分的相关内容800字左右。尽量少用虚词写精炼一点。
输出用大白话来写，内容为：本研究通过[研究主题]，揭示了[主要发现或结论]。丰富了[相关学科或领域]的理论体系，为[实践领域]提供了新的视角和解决方案。然而，本研究仍存在一些局限性，如[具体局限性描述]，这些局限性也为未来的研究提供了方向。[未来研究方向或建议]，以推动[相关领域]的持续发展。
输出格式为：
“5 结束语（800字左右）
XXX（3段话）”
大纲如下：`,
});

let formzhiayaoguanjianci = reactive({
  writerorg: `教学论文的写作，摘要是有一定规范的，请按标准的教学学术论文要求，根据提交的内容撰写摘要并修改润色。
要求如下：
1、说明提出问题的缘由，表明研究的范围和重要性；
2、简要说明研究过程和结论是如何得到的；
3、简要列出该研究的结果主要有什么，有什么新的发现
4、输出摘要是，一定要有固定的几个词，并在文中体现出来。如“为XXX，通过XXX，发现了XX，提供了XX”这样的句式句子结构。
5、摘要字数控制在200字-300字左右。
输出格式如下：
“摘要：为XXX，通过XXX，发现XX，提供XX。
关键词：XX；XX”
提交内容为：`,
});

let youhuayinyan = reactive({
  writerorg: `请逐条执行下面的命令：
1、使用更加科学术语、学术词汇和中性语气来改写、优化及精炼这篇学术论文大纲中的引言内容。
2、要避免重复使用词语和短语，并精炼这篇学术论文引言内容，减少冗余字数和词汇。
3、对引言部分内容强调如下：
学术论文“引言”请按标准的教学学术论文要求进行写作、修改、润色。关于“引言”部分要特别注意要求如下：第一点，论文写作的背景是什么？第二点，论文研究的需求是什么？第三点，这篇论文的任务是什么？第四点，写这篇论文的目的是什么？第五点，在任务或论文目标中前导性地介绍你要采用或构造什么方法、获得什么样的结果以及期望什么样的结论。第六点，“引言”输出段落为一段。总体连成一段输出，且输出字数要控制在300字-500字以内。
4、论文“引言”输出格式要求：按用一句话来描述“研究背景”，用一句话来描述“研究需求”，用一句话来描述“研究任务”，用一句话来描述“论文目标”。按这样的顺序介绍，一个也不能少，每一层意思只写一句话。
5、为提高引言质量，我们将大纲资料一并输入，请在优化时注意参考。
6、引言部分特定词汇避免要求确保没有使用“随着”、“综上所述”这个词汇。
7、“引言”输出段落为一段，不需要备注解性的话。总体写成一段，字数要控制在300字-500字以内。
格式为：
0 引言
XXX
大纲资料如下：`,
});

let youhuazhaiyaoguanjianci = reactive({
  writerorg: `请逐条执行下面的命令：
1、优化下面一篇学术论文的逻辑结构；
2、使用更加科学术语、学术词汇和中性语气来改写并精炼这篇文章。
3、要避免重复使用词语和短语，并精炼这篇文章，减少冗余字数，确保文章 400字符。
4、输出结构与原文一致。段落与段落之间不要换行。
输出格式下：
摘要：XX
关键词：XX
资料如下：`,
});

let youhuajiashuyu = reactive({
  writerorg: `请逐条执行下面的命令：
1、使用更加科学术语、学术词汇和中性语气来改写、优化及精炼这篇学术论文大纲中的“结束语部分”的内容。
2、要避免重复使用词语和短语，并精炼这篇学术论文“结束语部分”，减少冗余字数和冗余词汇。
3、对“结束语部分”强调如下：
学术论文“结束语部分”请按标准的教学学术论文要求进行写作、修改、润色。
5、“结束语部分”特定词汇避免要求确保没有使用“随着”、“综上所述”和“未来”这几个词汇：
7、“结束语部分”为三段，不需要备注解释性的话。字数在800字左右。
输出格式为：
“5  结束语
XXX”
资料如下：`,
});

// 生成标题
const onSubmit11 = () => {
  return post(baseurls + "/api/Kw/GetSearchZl", {
    bt: form.bt,
    sentence: "",
    subhs: "",
  })
    .then((res) => {
      form.writerorg2 = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};
const onSubmit12 = () => {
  let temphs = form.writerorg.replace("@标题@", form.bt);
  return post(baseurls + "/api/Kw/GetZlCuts", {
    bt: form.bt,
    sentence: form.writerorg2,
    subhs: temphs,
  })
    .then((res) => {
      form.resobj = res.data.resdata;
      form.keys = res.data.keys;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};
// 选定标题
const onSubmit13 = () => {
  return post(baseurls + "/api/Kw/GetTitleTj", {
    sentence: form.resobj,
  })
    .then((res) => {
      form2.bt = res.data.bt[0].title;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};

// 生成参考文献 异步
const onSubmit121 = () => {
  cankaowenxian.value = "参考文献：\n";
  post(baseurls + "/api/Kw/GetCkwxTjHJQ", {
    sentence: form2.bt,
  })
    .then((res) => {
      form.ckwx = res.data.list;
      form.ckwx.forEach((e) => {
        cankaowenxian.value += `${e}\n`;
      });
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};

// 生成大纲
const onSubmit21 = () => {
  // 替换话术
  let temphs = form2.writerorg.replace(/@标题@/g, form2.bt);
  form2.writerorg2 = temphs.replace(/@身份@/g, form2.zz);
  return post(baseurls + "/api/Kw/GetDgChatAPI", {
    sentence: form2.writerorg2 + form.keys,
  })
    .then((res) => {
      tigang.value = res.data.yw;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};

// 优化引言
const youhuayinyanfun = () => {
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: youhuayinyan.writerorg + tigang.value,
    bztype: "yinyan",
  })
    .then((res) => {
      yinyan.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};

// 生成摘要关键词
const clickzhaiyaoguanjianci = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: formzhiayaoguanjianci.writerorg + tigang.value,
    bztype: "zhaiyaoguanjianci",
  })
    .then((res) => {
      zhaiyaoguanjiancitemp.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};

// 优化摘要关键词
const youhuazhaiyaoguanjiancifun = () => {
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: youhuazhaiyaoguanjianci.writerorg + zhaiyaoguanjiancitemp.value,
    bztype: "youhuazhaiyaoguanjianci",
  })
    .then((res) => {
      zhaiyaoguanjianci.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};

// 生成第一部分
const onSubmit001 = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form01.writerorg + tigang.value,
    bztype: "diyibufen",
  })
    .then((res) => {
      reswenti1.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};
// 生成第二部分
const onSubmit002 = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form02.writerorg + tigang.value,
    bztype: "dierbufen",
  })
    .then((res) => {
      reswenti2.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};
// 生成第三部分
const onSubmit003 = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form03.writerorg + tigang.value,
    bztype: "disanbufen",
  })
    .then((res) => {
      reswenti3.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};
// 生成第四部分
const onSubmit004 = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form04.writerorg + tigang.value,
    bztype: "disibufen",
  })
    .then((res) => {
      reswenti4.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};
// 生成结束语部分
const onSubmit006 = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form06.writerorg + tigang.value,
    bztype: "jieshuyu",
  })
    .then((res) => {
      reswenti6.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};

// 优化结束语
const youhuajieshuyufun = () => {
  return post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: youhuajiashuyu.writerorg + reswenti6.value,
    bztype: "youhuajieshuyu",
  })
    .then((res) => {
      jieshuyu.value = res.data;
      //生成全文  标题  摘要关键字  引言   正文   参考文献
      reslunwen.value = `${form2.bt}\n\n${zhaiyaoguanjianci.value}\n${yinyan.value}\n${reswenti1.value}\n\n${reswenti2.value}\n\n${reswenti3.value}\n\n${reswenti4.value}\n\n${jieshuyu.value}\n\n${cankaowenxian.value}`;
    })
    .catch((err) => {
      loading.value = false;
      return Promise.reject({
        isNotErrorExpection: true, // 返回的地方加一个标志位，判断是否是错误类型，如果不是，那么说明可以是主动跳出循环的
      });
    });
};

// 同步生成大纲
const clickdagang = async () => {
  if (form2.bt.trim() == "") {
    ElMessage({
      message: "请填写标题",
      type: "warning",
    });
    return;
  }
  loading.value = true;
  loadingtext.value = "正在生成中，当前进度0%，请耐心等待...";
  // 初始化
  randsum = 0;
  let conouttime = 400 + Math.floor(Math.random() * 5) + 1;
  loadingfun(conouttime);
  // 顺序执行方法
  onSubmit121(); //参考文献
  await onSubmit21();
  youhuayinyanfun(); //引言
  await clickzhaiyaoguanjianci(); //生成摘要关键词
  youhuazhaiyaoguanjiancifun(); //优化摘要关键词
  await onSubmit001();
  await onSubmit002();
  await onSubmit003();
  await onSubmit004();
  await onSubmit006(); //生成结束语
  await youhuajieshuyufun(); //优化

  loading.value = false;
};

// 下载
const clickdownload = () => {
  if(jieshuyu.value==''){
    ElMessage({
      message: "请生成后再下载",
      type: "warning",
    });
    return
  }
  let xuyaofenxidelunwen = `${form2.bt}\n\n${zhaiyaoguanjianci.value}\n${yinyan.value}\n${reswenti1.value}\n\n${reswenti2.value}\n\n${reswenti3.value}\n\n${reswenti4.value}\n\n${jieshuyu.value}\n\n${cankaowenxian.value}`;
  loading.value = true;
  loadingtext.value = "下载中，请等待...";
  post("/wordFormat/settypeText", {
    text: xuyaofenxidelunwen,
    title:form2.bt,
  })
    .then((res) => {
      let downloadurl = "https://titletools-api.yuanpingjia.cn/" + res.result;
      const link = document.createElement("a");
      link.setAttribute("href", downloadurl); //设置下载文件的url地址
      //link.setAttribute('download', 'download'); //用于设置下载文件的文件名
      link.click();
      loading.value = false;
    })
    .catch((err) => {
      loading.value = false;
    });
};

const loadingfun = (outtime) => {
  let randNumtemp = Math.floor(Math.random() * 5) + 1;
  if (loading.value) {
    setTimeout(() => {
      randsum += randNumtemp;
      if (randsum < outtime) {
        let temprandnum = ((randsum / outtime) * 100).toFixed(2);
        loadingtext.value = `正在生成中，当前进度${temprandnum}%，请耐心等待...`;
        loadingfun(outtime);
      } else {
        loadingtext.value = `正在生成中，当前进度99.99%，请耐心等待...`;
      }
    }, randNumtemp * 1000);
  }
};
</script>

<style scoped>
:deep(.el-form-item__label) {
  background: #f5f7fa;
  height: 42px;
  line-height: 42px;
  font-size: 18px;
}
:deep(.cons-form .el-input__inner) {
  height: 40px;
  font-size: 18px;
}
:deep(.cons-form .el-textarea__inner) {
  min-height: 100px !important;
  font-size: 18px;
}
:deep(.cons-form .el-button) {
  width: auto;
  height: 50px;
  font-size: 18px;
}
.main {
  background: #fff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
}
.cons {
  width: 1200px;
  margin: auto;
  padding: 30px 0;
}
.cons-form {
  width: 100%;
}
.cons-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 0 0 10px 0;
}
.cons-subtitle {
  width: 100%;
  padding: 10px 30px;
  box-sizing: border-box;
  background: #f5f7fa;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  margin: auto;
  margin-bottom: 30px;
}
.custom-block {
  padding: 10px 16px;
  background-color: #ecf5ff;
  border-radius: 4px;
  border-left: 5px solid #409eff;
  margin: 20px 0 20px 0;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.con-btn {
  text-align: center;
  margin-bottom: 30px;
}
.cons-title-subtitle {
  color: #999;
  font-size: 14px;
}
.cons-title-subtitle p {
  margin: 0;
  padding: 0;
  text-align: center;
}
.qksx-list-con {
  font-size: 14px;
  padding: 20px 0 0 0;
}
.qksx-list-con:after {
  content: "";
  display: table;
  clear: both;
}
.xsqk-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xsqk-list {
  cursor: pointer;
}
.xsqk-list-title {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
}
.xsfx,
#echartsyyy {
  width: 1200px;
  height: 600px;
}
.loadings {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}
</style>
